
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { FaArrowLeft } from "react-icons/fa";
import { HashLink } from 'react-router-hash-link';
import { Helmet } from "react-helmet-async";


      <Helmet>
        <title>GJ Bullion - Privacy Policy</title>
        <meta name="description" content="GJ Bullion Privacy Policy - Learn how we collect, use, and protect your personal information for live gold and silver trading in Jobat & Indore." />
        <meta name="keywords" content="GJ Bullion Privacy Policy, gold silver trading, bullion data protection, Daksh Soni, Piyush Soni" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta property="og:title" content="GJ Bullion - Privacy Policy" />
        <meta property="og:description" content="Read GJ Bullion's Privacy Policy on protecting your personal data while trading gold & silver in Jobat & Indore." />
        <meta property="og:image" content="https://gjbullion.netlify.app/assets/logo.jpeg" />
        <meta property="og:url" content="https://gjbullion.netlify.app/privacy-policy" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="GJ Bullion - Privacy Policy" />
        <meta name="twitter:description" content="GJ Bullion Privacy Policy for secure bullion trading." />
        <meta name="twitter:image" content="https://gjbullion.netlify.app/assets/logo.jpeg" />
      </Helmet>
// Styled Components
const Container = styled.div`
  background-color: #000;
  color: #f5d76e;
  font-family: 'Segoe UI', sans-serif;
  min-height: 100vh;
`;

const Header = styled.header`
  background-color: #f5d76e;
  padding: 1rem 1.5rem;
  position: sticky;
  top: 0;
  z-index: 50;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
`;

const HeaderInner = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Brand = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  font-weight: bold;
  color: #000;

  img {
    border-radius: 50%;
  }

  span {
    font-weight: 700;
    font-size: 1.3rem;
  }
`;




const ButtonGroup = styled.div`
  display: flex;
  gap: 0.5rem;
  padding-bottom: 1rem;

  button {
    background-color: #000;
    color: #f5d76e;
    padding: 0.4rem 0.9rem;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover {
      background-color: #222;
    }
  }

  @media (min-width: 768px) {
    padding-bottom: 0;
  }
`;

const MenuToggle = styled.button`
  display: block;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #000;

  @media (min-width: 768px) {
    display: none;
  }
`;

const NavMenu = styled.div`
  display: ${({ open }) => (open ? "block" : "none")};
  background-color: #f5d76e;
  width: 100%;
  margin-top: 1rem;

  @media (min-width: 768px) {
    display: none; /* Hide mobile menu on desktop */
  }
`;


const NavLinks = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-bottom: 1rem;

  a {
    color: #000;
    text-decoration: none;
    padding: 0.4rem 0.8rem;
    border-radius: 4px;
    background: #fef7cc;
    font-weight: 500;
    transition: all 0.2s ease;

    &:hover {
      background: #000;
      color: #fff;
    }
  }

  @media (min-width: 768px) {
    flex-direction: row;
    padding-bottom: 0;
  }
`;

const BackBtn = styled.button`
  display: flex;
  align-items: center;
  background: #f5d76e;
  color: #000;
  border: none;
  margin-top: 1rem; // Or adjust spacing like 2rem, etc.
  padding-left: 1rem;
  padding: 8px 14px;
  font-weight: bold;
  border-radius: 5px;
  cursor: pointer;
  gap: 8px;
`;



const StyledFooter = styled.footer`
  background:    #0e1115ff;

  color: #ccc;
  padding: 3rem 1.5rem 2rem;
  font-size: 0.95rem;
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  max-width: 1150px;
  margin: 0 auto 2rem;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

const FooterCol = styled.div``;

const FooterTitle = styled.h4`
  color: #f5d76e;
  font-weight: 700;
  margin-bottom: 1rem;
`;

const FooterText = styled.p`
  margin-bottom: 0.5rem;
  color: #eee;
  font-size: 0.94rem;
`;

const FooterLink = styled.a`
  display: block;
  color: #bbb;
  margin-bottom: 0.4rem;
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    color: #f5d76e;
  }
`;

const BottomNote = styled.div`
  text-align: center;
  color: #666;
  border-top: 1px solid #333;
  padding-top: 1rem;
  font-size: 0.85rem;
`;


const FloatingButtons = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 999;

  a {
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: #e77575ff;
    color: white;
    padding: 0.6rem 1rem;
    border-radius: 50px;
    text-decoration: none;
    font-weight: 500;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

    &:hover {
      background-color: #ea1717ff;
    }

    img {
      width: 20px;
      height: 20px;
    }
  }
`;


const Left = styled.div`
  display: flex;
  align-items: center;
`;

const Right = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: flex;
    gap: 0.6rem;
    align-items: center;
  }
`;

const CenterNav = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: flex;
    gap: 2rem;
  }
`;

const LoginBtn = styled.button`
  background: transparent;
  border: 2px solid #000;
  color: #000;
  padding: 0.4rem 0.9rem;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background: #000;
    color: #f5d76e;
  }
`;

const RegisterBtn = styled.button`
  background: #000;
  color: #f5d76e;
  padding: 0.4rem 0.9rem;
  border-radius: 6px;
  border: none;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background-color: #222;
  }
    @keyframes fadeSlideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

`;



const PrivacyPolicy = () => {
      const [menuOpen, setMenuOpen] = useState(false);
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const [user, setUser] = useState(null);
    const navigate = useNavigate();

        useEffect(() => {
          const storedUser = localStorage.getItem("user");
          const justLoggedIn = localStorage.getItem("justLoggedIn");
    
          if (storedUser) {
            try {
              const parsedUser = JSON.parse(storedUser);
              setUser(parsedUser);
      
              if (justLoggedIn === "true") {
                setTimeout(() => {
                  localStorage.removeItem("justLoggedIn");
                }, 3000);
              }
      
            } catch (err) {
              console.error("Error parsing user:", err);
            }
          }
        }, []);

  return (
    <Container>

      <Header>
                  <HeaderInner>
                    <Left>
                      <Brand>
                        <img
                          src="/assets/logo.jpeg"
                          alt="GJ Bullion Logo"
                          style={{ width: "40px", height: "40px", marginRight: "0.5rem", borderRadius: "50%", objectFit: "cover" }}
                        />
                        <span>GJ Bullion</span>
                      </Brand>
                    </Left>
          
                    <CenterNav>
                      <NavLinks>
<HashLink
  smooth
  to="/#rates"
  onClick={() => setMenuOpen(false)}
  title="Live Indore Gold & Silver Rates"
>
  Live Rates
</HashLink>

<HashLink
  smooth
  to="/#booking"
  onClick={() => setMenuOpen(false)}
  title="Best Bullion Booking Desk in Indore"
>
  Booking Desk
</HashLink>

<Link
  to="/trades"
  onClick={() => setMenuOpen(false)}
  title="View Your Trade History with GJ Bullion"
>
  Trades
</Link>

<Link
  to="/about"
  onClick={() => setMenuOpen(false)}
  title="About GJ Bullion(Owned by Daksh & Piyush Soni )"
>
  About Us
</Link>

<Link
  to="/privacy-policy"
  onClick={() => setMenuOpen(false)}
  title="GJ Bullion Privacy Policy"
>
  Privacy Policy
</Link>

<Link
  to="/terms-and-conditions"
  onClick={() => setMenuOpen(false)}
  title="GJ Bullion Terms & Conditions"
>
  Terms & Conditions
</Link>
                      </NavLinks>
                    </CenterNav>
          
                    <Right>
            {user?.fullName ? (
              <div style={{ position: "relative" }}>
                <button
                  onClick={() => setShowProfileMenu(!showProfileMenu)}
                  style={{
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    background: "transparent",
                    border: "2px solid #000",
                    borderRadius: "6px",
                    padding: "0.4rem 0.8rem",
                    cursor: "pointer",
                    color: "#000"
                  }}
                >
                  👤 {user.fullName.split(" ")[0]}
                </button>
          
                {showProfileMenu && (
                  <div style={{
                    position: "absolute",
                    top: "110%",
                    right: 0,
                    background: "#fff",
                    color: "#000",
                    padding: "0.75rem 1rem",
                    borderRadius: "8px",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.25)",
                    zIndex: 100
                  }}>
                    <p><strong>Name:</strong> {user.fullName}</p>
                    <p><strong>Phone:</strong> {user.phone}</p>
                    <button
                      style={{
                        marginTop: "0.5rem",
                        background: "#e53935",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        padding: "0.4rem 0.75rem",
                        cursor: "pointer"
                      }}
                      onClick={() => {
                        localStorage.removeItem("user");
                        setUser(null);
                        setShowProfileMenu(false);
                        navigate("/");
                      }}
                    >
                      Logout
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <>
                <Link to="/login"><LoginBtn>Login</LoginBtn></Link>
                <Link to="/register"><RegisterBtn>Register</RegisterBtn></Link>
              </>
            )}
          </Right>
          
          
                    <MenuToggle onClick={() => setMenuOpen(!menuOpen)}>☰</MenuToggle>
                  </HeaderInner>
          
                  <NavMenu open={menuOpen}>
          
          
          
          
                    <NavLinks>
<HashLink
  smooth
  to="/#rates"
  onClick={() => setMenuOpen(false)}
  title="Live Indore Gold & Silver Rates"
>
  Live Rates
</HashLink>

<HashLink
  smooth
  to="/#booking"
  onClick={() => setMenuOpen(false)}
  title="Best Bullion Booking Desk in Indore"
>
  Booking Desk
</HashLink>

<Link
  to="/trades"
  onClick={() => setMenuOpen(false)}
  title="View Your Trade History with GJ Bullion"
>
  Trades
</Link>

<Link
  to="/about"
  onClick={() => setMenuOpen(false)}
  title="About GJ Bullion(Owned by Daksh & Piyush Soni )"
>
  About Us
</Link>

<Link
  to="/privacy-policy"
  onClick={() => setMenuOpen(false)}
  title="GJ Bullion Privacy Policy"
>
  Privacy Policy
</Link>

<Link
  to="/terms-and-conditions"
  onClick={() => setMenuOpen(false)}
  title="GJ Bullion Terms & Conditions"
>
  Terms & Conditions
</Link>
                    </NavLinks>
          
                              {/* 👤 Mobile profile */}
          <ButtonGroup>
            {!user?.fullName ? (
              <>
                <Link to="/login"><button>Login</button></Link>
                <Link to="/register"><button>Register</button></Link>
              </>
            ) : (
              <>
                <button
                  onClick={() => setShowProfileMenu(!showProfileMenu)}
                  style={{
                    fontWeight: 600,
                    border: "2px solid #000",
                    borderRadius: "6px",
                    padding: "0.4rem 0.8rem",
                    color: "#000",
                    background: "transparent",
                    width: "100%",
                    textAlign: "left",
                    marginBottom: "0.5rem"
                  }}
                >
                  👤 {user.fullName.split(" ")[0]}
                </button>
                {showProfileMenu && (
                  <div style={{
                    background: "#fff",
                    color: "#000",
                    padding: "0.75rem",
                    borderRadius: "8px",
                    marginTop: "0.5rem",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                    fontSize: "0.9rem"
                  }}>
                    <p><strong>Name:</strong> {user.fullName}</p>
                    <p><strong>Phone:</strong> {user.phone}</p>
                    <button
                      style={{
                        marginTop: "0.5rem",
                        background: "#e53935",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        padding: "0.4rem 0.75rem",
                        cursor: "pointer"
                      }}
                      onClick={() => {
                        localStorage.removeItem("user");
                        setUser(null);
                        setShowProfileMenu(false);
                        setMenuOpen(false);
                        navigate("/");
                      }}
                    >
                      Logout
                    </button>
                  </div>
                )}
              </>
            )}
          </ButtonGroup>
                  </NavMenu>
                </Header>

     <BackBtn onClick={() => navigate("/")}>
                     <FaArrowLeft /> <span>Home</span>
                   </BackBtn>
      <main style={{ padding: "3rem 1.5rem", maxWidth: "1100px", margin: "0 auto" }}>
        <h1 style={{ fontSize: "2rem", fontWeight: 700, color: "#f5d76e", marginBottom: "1.5rem" }}>
         📜 Privacy Policy
        </h1>
        <p style={{ color: "#ccc", lineHeight: 1.6, fontSize: "1rem" }}>
          At GJ BULLION, we value your privacy and are committed to protecting your personal data. This policy outlines how we collect, use, and safeguard your information when you use our website or mobile application.
        </p>
        <br />
        <p style={{ color: "#ccc", lineHeight: 1.6, fontSize: "1rem" }}>
          1. Information We Collect :-  <br />
⦿ Personal Information: Name, mobile number, email, address, etc., entered during registration or order booking.
<br />
⦿ Transactional Data: Order details such as silver/gold weight, order timing, and chosen delivery method.
<br />
⦿ Device & Usage Info: Automatically collected data including IP address, device type, and browser for analytics and security.
        </p>
        <br />
        <p style={{ color: "#ccc", lineHeight: 1.6, fontSize: "1rem" }}>
        2. How We Use Your Information? <br />
⦿ To process and confirm your bullion orders
<br />
⦿ To contact you regarding delivery or payment updates
<br />
⦿ For security, customer support, and service improvement
<br />
⦿ To comply with legal obligations
        </p>
                <br />

        <p style={{ color: "#ccc", lineHeight: 1.6, fontSize: "1rem" }}>
3. Data Security :- <br />
⦿ We implement strict security protocols to protect your information and never share it with third parties unless required by law.
        </p>
        <br />
        <p style={{ color: "#ccc", lineHeight: 1.6, fontSize: "1rem" }}>
4. Physical Pick-Up or Delivery :- <br />
⦿ Your booking (soda) is confirmed upon order, and you are required to complete payment within 1 hour. 
<br />
⦿ Pickup is available at our shop, or you can opt for delivery within 1-2 days. 
<br />
⦿ Delivery is subject to location and availability.
        </p>
        <br />
        <p style={{ color: "#ccc", lineHeight: 1.6, fontSize: "1rem" }}>
5. Your Rights :- <br />
⦿ You may request to review, update, or delete your personal data anytime by contacting us.
        </p>
        <br />

        <section style={{ marginTop: "3rem" }}>
  <h2 style={{ fontSize: "1.6rem", color: "#f5d76e", marginBottom: "1rem" }}>For any privacy concerns, reach out at:
</h2>
  <p style={{ color: "#ccc", lineHeight: 1.6 }}>
📞 +91 8878910881 <br /> ✉ gjbulliion@gmail.com
  </p>
</section>
     
      </main>
      <FloatingButtons>
  <a href="https://wa.me/919179315759" target="_blank" rel="noopener noreferrer">
    <img src="/assets/whatsapp.png" alt="WhatsApp" />
    
  </a>
  <a href="tel:+919179315759">📞</a>
</FloatingButtons>



<StyledFooter>
  <FooterGrid>
    <FooterCol>
  <FooterTitle>GJ BULLION</FooterTitle>

  <FooterText>
    Proudly serving traders and investors with honest pricing and real-time rates.
    Trusted by jewellers, wholesalers, and bullion buyers across India.
  </FooterText>

  <FooterText style={{ marginTop: "0.6rem" }}>
    Shop authentic gold & silver jewellery from our own showroom —{" "}
    <a
      href="https://jaggannathjewellers.netlify.app/"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "#f5d76e",
        textDecoration: "none",
        fontWeight: 800
      }}
    >
      Jaggannath Jewellers
    </a>
  </FooterText>
</FooterCol>


    <FooterCol>
      <FooterTitle>Quick Links</FooterTitle>
      <FooterLink href="#rates">Live Rates</FooterLink>
      <FooterLink href="#booking">Booking Desk</FooterLink>
      <FooterLink href="/trades">Trade History</FooterLink>
      <FooterLink href="/about">About Us</FooterLink>
      <FooterLink href="https://jaggannathjewellers.netlify.app" target="_blank">Shop Jewellery</FooterLink>
      <FooterLink
        href="https://play.google.com/store/apps/details?id=com.gjbullion.app&pcampaignid=web_share"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#48ff91", fontWeight: 600 }}
      >
        📲 Download Android App
      </FooterLink>
    </FooterCol>

    <FooterCol>
      <FooterTitle>Contact</FooterTitle>
      <FooterText>📍 5, SHIV MARG, JOBAT</FooterText>
      <FooterText>📞 +91 9179315759 +91 8878910881</FooterText>
      <FooterText>✉️ GJBULLIION@GMAIL.COM</FooterText>
    </FooterCol>

    
  </FooterGrid>

  <BottomNote className="bordered">
  © 2025 GJ BULLION. All rights reserved. &nbsp;&nbsp;|&nbsp;&nbsp;
  Developed by — <a href="https://codestatiion.netlify.app/" target="_blank" rel="noopener noreferrer">CODE STATIION</a>
</BottomNote>


</StyledFooter>
    </Container> 
  );
};

export default PrivacyPolicy;
